import React from 'react';

    const SectionHeading = ({ cityName, type }) => {
    const title = type === 1 ? `Popular Venues in ${cityName}` : `Artists in ${cityName}`;
    const subtitle = type === 1 ? 
                    `Discover the best venues in ${cityName} to host your special events, from luxurious banquet halls to scenic outdoor lawns and trendy rooftop spaces.` 
                    : 
                    `Find top artists in ${cityName} to elevate your event. Book skilled professionals to add creativity and charm to your special occasion!`;
    return (
        <section className="section-heading">
            <div className="section-heading-container">
                <h2 className="section-title">{title}</h2>
                <p className="section-subtitle">{subtitle}</p>    
            </div>   
        </section>
    );
    };

    export default SectionHeading;